#import "./AssetFields.graphql"

query GetAsset($id: ID!) {
  asset(id: $id) {
    ...AssetFields
  }
}
